import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import AppContext from '../../AppContext';
import { handleError } from '../../utils';
import { printMedicalConclusion } from '../../utils/medicalConclusionApi';
import { canAccessDocuments } from '../../utils/documentsAccess';
import { useAuth } from '../Auth/AuthContext';
import './DocumentsPage.scss';

export const DocumentsPage = () => {
  const appContext = React.useContext(AppContext);
  const { user, isOwner } = useAuth();
  const [printing, setPrinting] = useState(false);
  const allowed = canAccessDocuments(user, isOwner());

  if (!allowed) {
    return <Navigate to="/" replace />;
  }

  const handlePrint = async () => {
    setPrinting(true);
    try {
      await printMedicalConclusion();
    } catch (ex) {
      handleError(appContext!.setNotificationData, ex, 'Не удалось сформировать медицинское заключение');
    } finally {
      setPrinting(false);
    }
  };

  return (
    <div className="documents-page">
      <h2 className="page-heading">Документы</h2>
      <p className="documents-page__hint">
        Пустой бланк: фамилия, имя, отчество, дата рождения и даты заключения заполняются от руки.
      </p>
      <button
        type="button"
        className="btn"
        onClick={handlePrint}
        disabled={printing}
      >
        {printing ? 'Формирование PDF…' : 'Медицинское заключение'}
      </button>
    </div>
  );
};
